module.exports = __webpack_public_path__ + "img/pp_logo.c51559ed.png";